import AboutSoftwareDialog from "./AboutSoftwareDialog";

export default AboutSoftwareDialog;
